import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';
import { type CourtNoticesResponse } from '@/typings/api-models';

type THIS_API = ApiDefinition['/pacer-emails/creator/{creatorId}/get-pacer-emails']['GET'];

const PATH_TEMPLATE = '/pacer-emails/creator/{creatorId}/get-pacer-emails';

/**
 * Checks for a recent court notice that fuzzy-matches the given client name within the provided
 * time window. Returns the most recent match or null if none found.
 *
 * Note: matching is performed server-side via the `searchText` query parameter. Similar client
 * names (e.g. "John Smith" vs "John A. Smith") may produce false positives — the warning dialog
 * asks the user to verify in PACER before proceeding.
 */
const checkRecentClientNotice = async ({
  creatorId,
  clientName,
  startDate,
}: {
  creatorId: string;
  clientName: string;
  startDate: string;
}): Promise<CourtNoticesResponse | null> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path, {
    params: {
      page: 1,
      perPage: 1,
      searchText: clientName,
      sortDir: 'desc',
      startDate,
    },
  });
  return response.data.items[0] ?? null;
};

export default checkRecentClientNotice;
